import { Link } from 'react-router-dom';
import { heroData, statsData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20minimalist%20artistic%20background%20with%20soft%20warm%20coral%20and%20cream%20gradient%20tones%2C%20delicate%20sakura%20petal%20silhouettes%20floating%20in%20gentle%20breeze%2C%20abstract%20organic%20shapes%20with%20golden%20accents%2C%20dreamy%20atmospheric%20lighting%2C%20high%20end%20editorial%20aesthetic%2C%20soft%20focus%20background%20with%20warm%20natural%20light%2C%20no%20text%2C%20no%20people&width=1800&height=1000&seq=hero-bg-anzai-01&orientation=landscape"
          alt="安斋拉拉主题站"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-background-50/80 text-sm md:text-base tracking-widest uppercase mb-4 animate-fadeIn">
            官方主题落地页
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 leading-tight animate-fadeIn">
            {heroData.title}
          </h1>
          <p className="text-background-50/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8 animate-fadeIn">
            {heroData.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fadeIn">
            <Link
              to={heroData.ctaLink}
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaText}
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to={heroData.secondaryCtaLink}
              className="inline-flex items-center gap-2 px-8 py-3 border border-background-50/30 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {heroData.secondaryCtaText}
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 animate-fadeIn">
            {statsData.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}